import { DeviceManifest } from '@rapoo/device-sdk'
import {
  baseChannel0To7,
  baseChildDeviceEnabled,
  baseScreenLogo,
} from './generate/capabilityPresets'
import { p8BaseLightBandEffects, p8BaseLightScreenEffects } from './generate/lightingPresets'

/**
 * ESPR7PRO 底座设备清单
 */
const rapooESPR7PRO: DeviceManifest = {
  channel: ['china_cybercafe'],
  model: 'ESPR7PRO',
  mainControl: 'ESPR7PRO',
  type: 'base',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: 0x1450,
    currentPid: 0x1450,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 14,
        description: 'Base WebHID Command Interface',
        type: 'default',
      },
      {
        usagePage: 65280,
        usage: 2,
        description: 'Base Nordic Firmware Update Interface',
        type: 'update',
      },
      {
        usagePage: 65280,
        usage: 1,
        description: 'Base WCH Firmware Update Interface',
        type: 'updateWCH',
      },
    ],
  },
  driver: 'VT_nrf54L_Base',
  baseDisplay: 'lighting',
  ui: {
    assetsDir: 'manifests/ESPR7PRO',
    colors: {
      series: [
        {
          name: 'common.products.ESPR7PRO.Gray_Black_Red',
          value: '#F21111',
          key: 'Gray_Black_Red',
        },
        {
          name: 'common.products.ESPR7PRO.Raspberry_Pink',
          value: '#FF2558',
          key: 'Raspberry_Pink',
        },
      ],
      current: 'Gray_Black_Red',
    },
    icon: 'Hardware-Wireframe-Base',
    overview: true,
  },
  capabilities: [
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: [...p8BaseLightBandEffects, ...p8BaseLightScreenEffects],
      },
    },
    baseScreenLogo,
    baseChannel0To7,
    baseChildDeviceEnabled,
  ],
  layout: {
    image: 'devices/base/base.png',
    keys: [],
  },
}

export default rapooESPR7PRO
